<template>
  <v-card>
    <v-btn @click.stop="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card-text class="tree-view-container">
      <slot name="body"></slot>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import '../../style/_variables.scss'
export default {
  name: 'tree-view-modal'
}
</script>

<style lang="scss" scoped>
.tree-view-container {
  padding: 0;
  border: 1px solid white;
}
.btn {
  background-color: $grey-400;
  min-width: $length-large-xs;
  min-height: $length-large-xs;
  border-radius: $length-med-m;
  font-size: $font-size-med;
  color: $grey-800;
  height: $length-med-m;
  width: $length-med-m;
  align-self: end;
  margin: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/TreeViewModal.vue